import { useCallback } from "react";
import { OrganizationMemberClientAccessSource } from "@common/types/organizationMemberClientAccess";
import { useOrganizationDemoWorkspaceQuery } from "@api/organizationClient.api";
import { useScope } from "@state/scopeContext.lib";
import { useActiveOrganization } from "./useActiveOrganization";

export function useOrganizationDemoWorkspace() {
    const activeOrganization = useActiveOrganization();
    const { changeActiveWorkspace } = useScope();
    const { data: demoWorkspace } = useOrganizationDemoWorkspaceQuery(
        activeOrganization?.id,
    );

    const openDemoWorkspace = useCallback(
        (source: OrganizationMemberClientAccessSource) => {
            if (!demoWorkspace) {
                return;
            }

            changeActiveWorkspace(demoWorkspace.id, source);
        },
        [changeActiveWorkspace, demoWorkspace],
    );

    return { demoWorkspace, openDemoWorkspace };
}
